/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, Input} from '@angular/core';
import {ScheduleItem} from "../../models/schedule/ScheduleItem";
import {GeneralEntryItem} from "../../models/schedule/GeneralEntryItem";


@Component({
  selector: 'fixed-time-list-item',
  templateUrl: 'fixed-time-list-item.html'
})
export class FixedTimeListItem {

  @Input()
  item: GeneralEntryItem;

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/fixed-time-list-item/fixed-time-list-item.ts